import { NgModule } from '@angular/core'
import { BrowserModule } from '@angular/platform-browser'
import { AppRoutingModule } from './app-routing.module'
import { AppComponent } from './app.component'
import { LoginComponent } from './components/auth/login/login.component'
import { ModalModule } from 'ngx-bootstrap/modal'
import { AngularDualListBoxModule } from 'angular-dual-listbox'
import { AccordionModule } from 'ngx-bootstrap/accordion'
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker'
import { TabsModule } from 'ngx-bootstrap/tabs'
import { PaginationModule } from 'ngx-bootstrap/pagination'
import { ProgressbarModule } from 'ngx-bootstrap/progressbar'
import { BsDropdownModule } from 'ngx-bootstrap/dropdown'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http'
import { StoreModule } from '@ngrx/store'
import { appReducer } from './store/reducer/app.reducer'
import { EffectsModule } from '@ngrx/effects'
import { ToastrModule } from 'ngx-toastr'
import { DashboardEffects } from './store/effect/dashboard.effect'
import { ActivityDashboardComponent } from './components/activity/dashboard/activity-dashboard.component'
import { GreetingComponent } from './components/common/greeting/greeting.component'
import { ViewForSelectorComponent } from './components/common/view-for-selector/view-for-selector.component'
import { CategorySelectorComponent } from './components/common/category-selector/category-selector.component'
import { InitializeEffects } from './store/effect/initialize.effect'
import { ActivityEffects } from './store/effect/activity.effect'
import { PendingItemsTableComponent } from './components/common/pending-items-table/pending-items-table.component'
import { VarDirective } from './directives/ng-var.directive'
import { SideNavComponent } from './components/common/side-nav/side-nav.component'
import { CreateActivityComponent } from './components/activity/create-activity/create-activity.component'
import { ValidationComponent } from './components/common/validation/validation.component'
import { AssignToSelectorComponent } from './components/common/assign-to-selector/assign-to-selector.component'
import { MatAutocompleteModule } from '@angular/material/autocomplete'
import { EmployeeSelectorComponent } from './components/common/employee-selector/employee-selector.component'
import { MatFormFieldModule } from '@angular/material/form-field'
import { CompanySelectorComponent } from './components/common/company-selector/company-selector.component'
import { GovernmentBusinessDashboardComponent } from './components/government-business/dashboard/government-business-dashboard.component'
import { GovernmentBusinessEffect } from './store/effect/government-business.effect'
import { CreateGovernmentBusinessComponent } from './components/government-business/create-government-business/create-government-business.component'
import { GovernmentBusinessSummaryComponent } from './components/government-business/summary/government-business-summary.component'
import { ClientSelectorComponent } from './components/client-selector/client-selector.component'
import { AuthEffects } from './store/effect/auth.effect'
import { AuthInterceptor } from './services/interceptor/auth.interceptor'
import { HeaderComponent } from './components/common/header/header.component'
import { StatsCardComponent } from './components/common/stats-card-group/stats-card/stats-card.component'
import { StatsCardGroupComponent } from './components/common/stats-card-group/stats-card-group.component'
import { ComplianceDashboardComponent } from './components/compliance-dashboard/compliance-dashboard.component'
import { CustomWeekHeaderComponent } from './components/common/custom-week-header/custom-week-header.component'
import { CalendarModule, DateAdapter } from 'angular-calendar'
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns'
import { ForgotPasswordComponent } from './components/auth/forgot-password/forgot-password.component'
import { ResetPasswordComponent } from './components/auth/reset-password/reset-password.component'
import { MultipleFileSelectorComponent } from './components/common/multiple-file-selector/multiple-file-selector.component'
import { PasswordInputComponent } from './components/common/password-input/password-input.component'
import { ActivitySummaryComponent } from './components/activity/summary/activity-summary.component'
import { CommonEffects } from './store/effect/common.effect'
import { QueryEffects } from './store/effect/query.effect'
import { CommentComponent } from './components/common/comment/comment.component'
import { CreateQueryComponent } from './components/query/create-query/create-query.component'
import { QueryDashboardComponent } from './components/query/query-dashboard/query-dashboard.component'
import { QueryDetailsComponent } from './components/query/query-details/query-details.component'
import { StatusSelectorComponent } from './components/common/status-selector/status-selector.component'
import { EditKnowledgeArticleComponent } from './components/knowledge/edit/edit-knowledge-article.component'
import { KnowledgeSearchComponent } from './components/knowledge/knowledge-search/knowledge-search.component'
import { KnowledgeQuickSelectComponent } from './components/knowledge/quick-select/knowledge-quick-select.component'
import { ViewKnowledgeArticleComponent } from './components/knowledge/view-knowledge-article/view-knowledge-article.component'
import { ActivityDetailsComponent } from './components/activity/activity-details/activity-details.component'
import { SummaryDataTableComponent } from './components/common/summary-data-table/summary-data-table.component'
import { KnowledgeEffects } from './store/effect/knowledge.effect'
import { SafeUrlPipe } from './pipe/safeUrl.pipe'
import { SelectPeriodSelectorComponent } from './components/common/select-period-selector/select-period-selector.component'
import { GovernmentBusinessDetailsComponent } from './components/government-business/government-business-details/government-business-details.component'
import { MatCardModule } from '@angular/material/card'
import { ColumnFilterPipe } from './components/import/column-filter.pipe'
import { BulkImportComponent } from './components/import/bulk-import/bulk-import-component'
import { StoreDevtoolsModule } from '@ngrx/store-devtools'
import { environment } from '../environments/environment'
import { KnowledgeSummaryComponent } from './components/knowledge/knowledge-summary/knowledge-summary.component'
import { ScrollingModule } from '@angular/cdk/scrolling'
import { CreateCalendarComponent } from './components/calendar-info/create-calendar/create-calendar.component'
import { SummaryCalendarComponent } from './components/calendar-info/summary/summary-calendar.component'
import { EmployeeProfileComponent } from './components/employee-info/employee-profile/employee-profile.component'
import { DataRepositorySearchComponent } from './components/data-repository/search/data-repository-search.component'
import { DataRepositorySummaryComponent } from './components/data-repository/summary/data-repository-summary.component'
import { DataRepositoryQuickSelectComponent } from './components/data-repository/quick-select/data-repository-quick-select.component'
import { AnnouncementSummaryComponent } from './components/circular-communication/summary/announcement-summary.component'
import { NewAnnouncementComponent } from './components/circular-communication/new-announcement/new-announcement.component'
import { NgxEditorModule } from 'ngx-editor'
import { EmployeeSummaryComponent } from './components/employee-info/employee-summary/employee-summary.component'
import { EmployeeEffects } from './store/effect/employee.effect'
import { QuerySummaryComponent } from './components/query/query-summary/query-summary.component'
import { AnnouncementEffects } from './store/effect/announcement.effect'
import { ActivityPendingItemsComponent } from './components/activity/pending-items/activity-pending-items.component'
import { SettingsComponent } from './components/settings/settings.component'
import { SettingsEffect } from './store/effect/settings.effect'
import { CalendarEffects } from './store/effect/calendar.effect'
import { AttachmentListComponent } from './components/common/attachment-list/attachment-list.component'
import {
  MsalModule,
  MsalBroadcastService,
  MsalService,
  MsalRedirectComponent
} from '@azure/msal-angular'
import {
  PublicClientApplication,
  BrowserCacheLocation,
  InteractionType
} from '@azure/msal-browser'
import { BackButtonComponent } from './components/common/back-button/back-button.component'
import { MatOptionModule } from '@angular/material/core'
import { DatePipe, NgForOf } from '@angular/common'
import { AutoHeightDirective } from './directives/auto-height.directive'
import { TagInputModule } from 'ngx-chips'
import { ReportsComponent } from './components/reports/reports.component'
import { DocumentPreviewComponent } from './components/common/document-preview/document-preview.component'
import { PdfViewerModule } from 'ng2-pdf-viewer'
import { Form11SidebarComponent } from './components/form11-sidebar/form11-sidebar.component'
import { Form11Component } from './components/form11/form11.component'
import { SwitchComponent } from './components/common/switch/switch.component'
import { OfflineTrackerSummaryComponent } from './components/offline-tracker/summary/offline-tracker-summary.component'
import { CreateNewOfflineTrackerComponent } from './components/offline-tracker/create/create-new-offline-tracker.component'
import { OfflineTrackerDetailsComponent } from './components/offline-tracker/details/offline-tracker-details.component'
import { MultiDropdownAddOptionComponent } from './components/common/multi-dropdown-add-option/multi-dropdown-add-option.component'
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown'
import { OfflineTrackerEffects } from './store/effect/offline-tracker.effect'
import { EntityWiseInfoComponent } from './components/entity-wise-info/entity-wise-info.component'
import { QuillModule } from 'ngx-quill'
import { DynamicModalComponent } from './components/common/dynamic-modal/dynamic-modal.component'
import { OnboardingWizardComponent } from './components/onboarding-wizard/onboarding-wizard.component'
import { MatStepperModule } from '@angular/material/stepper'
import { MatButtonModule } from '@angular/material/button'
import { MatInputModule } from '@angular/material/input'
import { CompanyStepComponent } from './components/onboarding-wizard/steps/company-step/company-step.component'
import { CompanyEntityStepComponent } from './components/onboarding-wizard/steps/company-entity-step/company-entity-step.component'
import { SopSettingsStepComponent } from './components/onboarding-wizard/steps/sop-settings-step/sop-settings-step.component'
import { EmployeeStepComponent } from './components/onboarding-wizard/steps/employee-step/employee-step.component'
import { ImportWrapperComponent } from './components/onboarding-wizard/steps/employee-step/substeps/import-wrapper/import-wrapper.component'
import { AdminAssignmentComponent } from './components/onboarding-wizard/steps/employee-step/substeps/admin-assignment/admin-assignment.component'
import { MatButtonToggleModule } from '@angular/material/button-toggle'
import { OtherCompanySettingsComponent } from './components/onboarding-wizard/steps/other-company-settings/other-company-settings.component'
import { OnboardingEffects } from './store/effect/onboarding.effect'
import { AdminNewJoineeWfScreenConfigComponent } from './components/onboarding-wizard/steps/new-joinee-wf/admin-newjoinee-wf-screen-config/admin-newjoinee-wf-screen-config.component'
import { EmployeeNewJoineeWfScreenConfigComponent } from './components/onboarding-wizard/steps/new-joinee-wf/employee-newjoinee-wf-screen-config/employee-newjoinee-wf-screen-config.component'
import { Form11PdfScreenConfigComponent } from './components/onboarding-wizard/steps/new-joinee-wf/form11-pdf-screen-config/form11-pdf-screen-config.component'
import { MainScreenConfigComponent } from './components/onboarding-wizard/steps/new-joinee-wf/main-screen-config/main-screen-config.component'
import { SharedWfScreenConfigComponent } from './components/onboarding-wizard/steps/new-joinee-wf/shared-wf-screen-config/shared-wf-screen-config.component'
import { NgOtpInputModule } from 'ng-otp-input'
import { LandingComponent } from './components/auth/landing/landing.component'

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    ActivityDashboardComponent,
    GreetingComponent,
    ViewForSelectorComponent,
    CategorySelectorComponent,
    PendingItemsTableComponent,
    VarDirective,
    SideNavComponent,
    StatsCardComponent,
    CreateActivityComponent,
    ValidationComponent,
    AssignToSelectorComponent,
    EmployeeSelectorComponent,
    CompanySelectorComponent,
    GovernmentBusinessDashboardComponent,
    CreateGovernmentBusinessComponent,
    GovernmentBusinessSummaryComponent,
    CompanySelectorComponent,
    ClientSelectorComponent,
    HeaderComponent,
    StatsCardGroupComponent,
    ComplianceDashboardComponent,
    CustomWeekHeaderComponent,
    NewAnnouncementComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    MultipleFileSelectorComponent,
    PasswordInputComponent,
    ActivitySummaryComponent,
    PasswordInputComponent,
    CreateQueryComponent,
    QueryDashboardComponent,
    QueryDetailsComponent,
    CommentComponent,
    StatusSelectorComponent,
    EditKnowledgeArticleComponent,
    KnowledgeSearchComponent,
    KnowledgeQuickSelectComponent,
    ViewKnowledgeArticleComponent,
    ActivityDetailsComponent,
    SummaryDataTableComponent,
    SafeUrlPipe,
    GovernmentBusinessDetailsComponent,
    KnowledgeSummaryComponent,
    CreateCalendarComponent,
    SummaryCalendarComponent,
    EmployeeProfileComponent,
    DataRepositorySearchComponent,
    DataRepositorySummaryComponent,
    DataRepositoryQuickSelectComponent,
    AnnouncementSummaryComponent,
    EmployeeSummaryComponent,
    QuerySummaryComponent,
    ActivityPendingItemsComponent,
    BulkImportComponent,
    ColumnFilterPipe,
    SelectPeriodSelectorComponent,
    SettingsComponent,
    AttachmentListComponent,
    BackButtonComponent,
    AutoHeightDirective,
    ReportsComponent,
    DocumentPreviewComponent,
    Form11SidebarComponent,
    Form11Component,
    SwitchComponent,
    OfflineTrackerSummaryComponent,
    CreateNewOfflineTrackerComponent,
    OfflineTrackerDetailsComponent,
    MultiDropdownAddOptionComponent,
    EntityWiseInfoComponent,
    DynamicModalComponent,
    OnboardingWizardComponent,
    CompanyStepComponent,
    CompanyEntityStepComponent,
    DynamicModalComponent,
    MainScreenConfigComponent,
    SharedWfScreenConfigComponent,
    EmployeeNewJoineeWfScreenConfigComponent,
    AdminNewJoineeWfScreenConfigComponent,
    Form11PdfScreenConfigComponent,
    SopSettingsStepComponent,
    EmployeeStepComponent,
    ImportWrapperComponent,
    AdminAssignmentComponent,
    Form11PdfScreenConfigComponent,
    OtherCompanySettingsComponent,
    LandingComponent
  ],
  imports: [
    FormsModule,
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    ReactiveFormsModule,
    AccordionModule.forRoot(),
    BsDropdownModule.forRoot(),
    BsDatepickerModule.forRoot(),
    TabsModule.forRoot(),
    PaginationModule.forRoot(),
    ProgressbarModule.forRoot(),
    AngularDualListBoxModule,
    ModalModule.forRoot(),
    HttpClientModule,
    StoreModule.forRoot(appReducer),
    StoreDevtoolsModule.instrument({
      maxAge: 100,
      logOnly: environment.production
    }),
    EffectsModule.forRoot([
      AuthEffects,
      DashboardEffects,
      InitializeEffects,
      ActivityEffects,
      GovernmentBusinessEffect,
      QueryEffects,
      CommonEffects,
      KnowledgeEffects,
      EmployeeEffects,
      SettingsEffect,
      AnnouncementEffects,
      CalendarEffects,
      OfflineTrackerEffects,
      OnboardingEffects
    ]),
    ToastrModule.forRoot({
      timeOut: 5000,
      positionClass: 'toast-top-right',
      preventDuplicates: true
    }),
    MatAutocompleteModule,
    MatFormFieldModule,
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory
    }),
    MatCardModule,
    ScrollingModule,
    NgxEditorModule,
    MsalModule.forRoot(
      new PublicClientApplication({
        auth: {
          clientId: 'DUMMY-CLIENT-ID',
          authority: 'https://login.microsoftonline.com/common',
          redirectUri: '/'
        },
        cache: {
          cacheLocation: BrowserCacheLocation.LocalStorage
        },
        system: {
          allowNativeBroker: false
        }
      }),
      {
        interactionType: InteractionType.Popup,
        authRequest: {}
      },
      {
        interactionType: InteractionType.Popup,
        protectedResourceMap: new Map()
      }
    ),
    MatAutocompleteModule,
    MatOptionModule,
    NgForOf,
    TagInputModule,
    PdfViewerModule,
    NgMultiSelectDropDownModule.forRoot(),
    QuillModule.forRoot(),
    MatStepperModule,
    MatButtonModule,
    MatInputModule,
    MatButtonToggleModule,
    NgOtpInputModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    MsalService,
    MsalBroadcastService,
    DatePipe
  ],
  bootstrap: [AppComponent, MsalRedirectComponent]
})
export class AppModule {}
